export type ProductThemeKey =
  | 'defter-kasa'
  | 'kozmik-gunluk'
  | 'anilar-muzesi';

export interface ProductCardTheme {
  rowBorder: string;
  rowHover: string;
  rowAlt: string;
  iconBox: string;
  tag: string;
  meta: string;
  progressLabel: string;
  progressTrack: string;
  progressFill: string;
  progressValue: string;
  statBox: string;
  statLabel: string;
  statValue: string;
}

export const PRODUCT_CARD_THEMES: Record<ProductThemeKey, ProductCardTheme> = {
  'defter-kasa': {
    rowBorder: 'border-sky-300/12',
    rowHover: 'hover:bg-sky-400/[0.04]',
    rowAlt: 'bg-[#0b1421]/45',
    iconBox: 'border-sky-300/25 bg-[#0e1d38]',
    tag: 'text-sky-200/65 border-sky-300/18 hover:border-sky-300/35 hover:text-sky-100',
    meta: 'text-sky-100/50',
    progressLabel: 'text-sky-200/60',
    progressTrack: 'bg-sky-300/15',
    progressFill: 'bg-gradient-to-r from-sky-600 via-sky-500 to-cyan-300',
    progressValue: 'text-sky-100/75',
    statBox: 'border-sky-300/14 bg-[#0d1728]',
    statLabel: 'text-sky-200/45',
    statValue: 'text-sky-100',
  },
  'kozmik-gunluk': {
    rowBorder: 'border-purple-500/14',
    rowHover: 'hover:bg-purple-500/[0.05]',
    rowAlt: 'bg-[#14101d]/40',
    iconBox: 'border-purple-500/25 bg-[#181225]',
    tag: 'text-purple-200/70 border-purple-500/22 hover:border-purple-400/40 hover:text-purple-100',
    meta: 'text-purple-100/45',
    progressLabel: 'text-purple-300/55',
    progressTrack: 'bg-purple-500/16',
    progressFill: 'bg-gradient-to-r from-purple-700 via-purple-500 to-fuchsia-300',
    progressValue: 'text-purple-200/75',
    statBox: 'border-purple-500/16 bg-[#151021]',
    statLabel: 'text-purple-200/45',
    statValue: 'text-purple-100',
  },
  'anilar-muzesi': {
    rowBorder: 'border-red-800/20',
    rowHover: 'hover:bg-red-900/[0.06]',
    rowAlt: 'bg-[#160c0c]/50',
    iconBox: 'border-red-800/30 bg-[#1a0d0d]',
    tag: 'text-red-400/65 border-red-800/30 hover:border-red-700/45 hover:text-red-300',
    meta: 'text-red-300/45',
    progressLabel: 'text-red-300/55',
    progressTrack: 'bg-red-900/20',
    progressFill: 'bg-gradient-to-r from-red-900 via-red-700 to-red-500',
    progressValue: 'text-red-300/70',
    statBox: 'border-red-800/20 bg-[#120808]',
    statLabel: 'text-red-300/45',
    statValue: 'text-red-200/80',
  },
};
